import { Backdrop, CircularProgress, SxProps } from '@mui/material';
import React from 'react';

export interface TwBackdropProps {
  isOpen: boolean;
  className?: string;
  position?: any;
  sx?: SxProps;
}

const TwBackdrop: React.FC<TwBackdropProps> = ({
  isOpen,
  className,
  position,
  sx
}): JSX.Element => {
  return (
    <Backdrop
      className={className + (isOpen ? ' tid-backdrop__visible' : ' tid-backdrop__hidden')}
      sx={{
        position: position || 'inherit',
        color: '#fff',
        zIndex: 10000,
        width: '100%',
        backgroundColor: 'transparent',
        ...sx
      }}
      open={isOpen}
    >
      <CircularProgress role={'alert'} />
    </Backdrop>
  );
};

export default TwBackdrop;
